function cov_8izfu1rqa() {
  var path = "/__w/code/code/js/packages/bricks/src/core/Icon/SpritesheetIcons/ChevronRight12.tsx";
  var hash = "5cee0f12536d99f60c98e47c182e9a67f0e5bb89";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/__w/code/code/js/packages/bricks/src/core/Icon/SpritesheetIcons/ChevronRight12.tsx",
    statementMap: {
      "0": {
        start: {
          line: 1,
          column: 56
        },
        end: {
          line: 4,
          column: 1
        }
      }
    },
    fnMap: {},
    branchMap: {},
    s: {
      "0": 0
    },
    f: {},
    b: {},
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "5cee0f12536d99f60c98e47c182e9a67f0e5bb89"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_8izfu1rqa = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_8izfu1rqa();
var Icon = (cov_8izfu1rqa().s[0]++, {
  name: 'chevron-right-12',
  svg: "<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M4.11612 2.11612C4.60427 1.62796 5.39573 1.62796 5.88388 2.11612L8.88388 5.11612C9.37204 5.60427 9.37204 6.39573 8.88388 6.88388L5.88388 9.88388C5.39573 10.372 4.60427 10.372 4.11612 9.88388C3.62796 9.39573 3.62796 8.60427 4.11612 8.11612L6.23223 6L4.11612 3.88388C3.62796 3.39573 3.62796 2.60427 4.11612 2.11612Z\" fill=\"currentColor\"/>"
});
export default Icon;